import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

// Was getting warnings to removed the link, not sure what the best solution is yet.
// https://github.com/ReactTraining/react-router/issues/617
// <Link to={'/courses/library/' + props.course.slug} className='button'>Find out more</Link>

const CourseCarouselItem = (props) => (
  <li>
    <Link to={'/courses/' + props.course.slug} className='course-card'>
      <h4 className='course-card__heading'>
        {props.course.title}
      </h4>
      <div className='course-card__meta'>
        <span className='pill'>{props.course.type}</span>
        <span className='pill'>£{props.course.courseOptions[0].price}</span>
      </div>
      <div className='course-card__description'>
        <p>{props.course.description}</p>
      </div>
      <span className='button'>Find out more</span>
    </Link>
  </li>
);

CourseCarouselItem.propTypes = {
  course: PropTypes.object
};

export default CourseCarouselItem;



// WEBPACK FOOTER //
// ./src/components/CourseCarouselItem/index.js